export const parseDataFromLiveBets = (bets) => {
  return bets
    .map((bet) => {
      const additionalData = bet.additionalParams || bet.betData;
      if (additionalData.markets.length > 1) {
        return additionalData.markets.map((market) => ({
          userId: bet.userId,
          freeBetId: bet.freeBetId,
          playerExternalId: bet.playerExternalId,
          currencyCode: bet.currencyCode,
          additionalParams: { markets: [market] },
          ...market,
        }));
      }
      return {
        userId: bet.userId,
        freeBetId: bet.freeBetId,
        playerExternalId: bet.playerExternalId,
        currencyCode: bet.currencyCode,
        additionalParams: { markets: [additionalData.markets[0]] },
        ...additionalData.markets[0],
      };
    })
    .flat();
};
